"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiCompleteNewPasswordResponse = instanceOfApiCompleteNewPasswordResponse;
exports.ApiCompleteNewPasswordResponseFromJSON = ApiCompleteNewPasswordResponseFromJSON;
exports.ApiCompleteNewPasswordResponseFromJSONTyped = ApiCompleteNewPasswordResponseFromJSONTyped;
exports.ApiCompleteNewPasswordResponseToJSON = ApiCompleteNewPasswordResponseToJSON;
exports.ApiCompleteNewPasswordResponseToJSONTyped = ApiCompleteNewPasswordResponseToJSONTyped;
/**
 * Check if a given object implements the ApiCompleteNewPasswordResponse interface.
 */
function instanceOfApiCompleteNewPasswordResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ApiCompleteNewPasswordResponseFromJSON(json) {
    return ApiCompleteNewPasswordResponseFromJSONTyped(json, false);
}
function ApiCompleteNewPasswordResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'message': json['message'],
    };
}
function ApiCompleteNewPasswordResponseToJSON(json) {
    return ApiCompleteNewPasswordResponseToJSONTyped(json, false);
}
function ApiCompleteNewPasswordResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'message': value['message'],
    };
}
